import { FormMember } from "../Model/FormMember";
export class FormMembersFactory {
    constructor(eventsChannelFactory) {
        this.eventsChannelFactory = eventsChannelFactory;
    }
    createFormMember(instance, userId, isOwner = false, isSigned = false, signDate = null, buddyId = null) {
        const eventsChannel = this.eventsChannelFactory.createEventsChannel(instance.id);
        return new FormMember(eventsChannel, instance, userId, isOwner, isSigned, signDate, buddyId);
    }
}
